import { render, staticRenderFns } from "./WealthSummary.vue?vue&type=template&id=7241ca2a&scoped=true&"
import script from "./WealthSummary.vue?vue&type=script&lang=ts&"
export * from "./WealthSummary.vue?vue&type=script&lang=ts&"
import style0 from "./WealthSummary.vue?vue&type=style&index=0&id=7241ca2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7241ca2a",
  null
  
)

export default component.exports